import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const WxLaunchApp = Loadable({
    loader: () => import(/* webpackChunkName: "WxLaunchApp" */ './wxLaunchApp'),
    loading: () => <div />,
});
